import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({
    meta: [
      { title: "Platform admin — Lumvio" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <Outlet />,
});
